import { MagnifyingGlass, X } from '@phosphor-icons/react';
import { id } from 'date-fns/locale';
import { useSelector } from 'react-redux';

interface SearchFilterProps {
    value: string | null;
    onChange: (value: string) => void;
    onApply: () => void;
    onClear?: () => void;
    className?: string;
}

function SearchFilter({ value, onChange, onApply, onClear, className = '' }: SearchFilterProps) {
    const hasValue = (value ?? '').trim().length > 0;
    const i18n = useSelector((state: any) => state.i18n.i18n);
    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter') {
            onApply();
        }
    };

    const handleClear = () => {
        onChange('');
        if (onClear) {
            onClear();
        }
    };

    return (
        <div className={`flex flex-col relative max-w-[300px] mb-16 ${className}`}>
            <input
                className={`text-layout-textcolor bg-input-backgroundColor w-full p-3 border border-2 border-input-borderColor rounded-lg outline-none focus:border-primary transition-all duration-100 ${
                    hasValue ? 'pr-16' : 'pr-10'
                }`}
                type="text"
                value={value ?? ''}
                onChange={(e) => onChange(e.target.value)}
                placeholder={i18n.translate({ id: 'filter.placeholder', sourceName: 'Main' })}
                onKeyDown={handleKeyDown}
            />

            <span className="absolute right-3 h-full flex items-center gap-2">
                {hasValue ? (
                    <div
                        className="w-4 h-4 cursor-pointer text-layout-textcolor hover:text-primary transition-colors"
                        onClick={(e) => {
                            e.stopPropagation();
                            handleClear();
                        }}
                    >
                        <X />
                    </div>
                ) : (
                    <></>
                )}

                <div
                    className="w-4 h-4 cursor-pointer text-layout-textcolor hover:text-primary transition-colors"
                    onClick={(e) => {
                        e.stopPropagation();
                        onApply();
                    }}
                >
                    <MagnifyingGlass />
                </div>
            </span>
        </div>
    );
}

export default SearchFilter;
